/* global axios */
import ApiClient from '../ApiClient';

class CaptainBusinessPresets extends ApiClient {
  constructor() {
    super('captain/business_presets', { accountScoped: true });
  }

  apply(presetId) {
    return axios.post(`${this.url}/${presetId}/apply`);
  }

  sync(presetId, assistantId) {
    return axios.post(`${this.url}/${presetId}/sync`, {
      assistant_id: assistantId,
    });
  }
}

export default new CaptainBusinessPresets();
